"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placementDirection = exports.oppositeDirectionOf = exports.TOP = exports.RIGHT = exports.LEFT = exports.BOTTOM = void 0;
var _Theme = require("../themes/Theme");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var TOP = exports.TOP = "top";
var BOTTOM = exports.BOTTOM = "bottom";
var LEFT = exports.LEFT = "left";
var RIGHT = exports.RIGHT = "right";
var oppositeDirectionOf = exports.oppositeDirectionOf = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, TOP, BOTTOM), BOTTOM, TOP), LEFT, RIGHT), RIGHT, LEFT);
var placementDirection = exports.placementDirection = function placementDirection(placement, direction) {
  if (placement === TOP || placement === BOTTOM) {
    return placement;
  }
  return direction === _Theme.Direction.rtl ? oppositeDirectionOf[placement] : placement;
};